import { ChimeraMeUser } from '@/models/user/user.model';

export function hasEveryFlag(user: ChimeraMeUser, requiredFlags: string[]): boolean {
  const userFlags = user.featureFlags || [];
  return requiredFlags.every((flag) => !!userFlags[flag]);
}
